:root {
  --cta-link-color: @ig-grey-900;
  --cta-link-hover-color: @ig-red-600;
  --cta-font-size: 16px;
  --cta-line-height: 24px;
  --cta-link-transform: rotate(0deg);
  --cta-link-margin: 0;
  --cta-link-ml: 0; // ml -> margin left
  --cta-link-mb: @anchor-spacing; //mb -> margin bottom
  --cta-link-text-margin: 0 0 0 5px;
  --cta-link-text-height: 9px;
  --cta-link-text-width: 9px;
  --cta-link-padding: 0;
}

// EU Theme Colors - Light Mode
@eu-primary-bg: #31e7ff;
@eu-primary-text: #00092d;
@eu-secondary-text: #39405c;
@eu-secondary-border: #39405c;

// EU Theme Colors - Dark Mode
@eu-dark-secondary-text: #edf0f2;
@eu-dark-secondary-border: #edf0f2;

@cta-primary-color: #67c058;
@cta-primary-hover-color: #369136;

a {
  text-decoration: none;
}

h3 {
  display: inline-block;
  color: @ig-grey-900;
  font-size: 22px;
  line-height: 30px;
  .MatterMedium();
  margin-bottom: 5px;
}

.cta-wrapper.cta--center {
  margin-left: auto;
  margin-right: auto;
}

.cta-wrapper.cta--right {
  margin-left: auto;
}

.cta-wrapper.primary,
.cta-wrapper.secondary,
.cta-wrapper.secondary--dark {
  height: 44px;
  width: 100%;
  max-width: 280px;
  font-size: 20px;
  line-height: 26px;
  .MatterSemiBold();
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: var(--cta-link-ml, 0);
  margin-bottom: 20px;
  border: 1px solid;

  &:hover {
    text-decoration: none;
  }

  .cta__text {
    padding: 0 10px;
  }
}

.cta-wrapper .prefix-wrapper {
  display: flex;
  align-items: center;
}

.cta-wrapper .suffix-wrapper {
  display: flex;
  align-items: center;
}

.cta-wrapper.primary {
  color: @white;
  background-color: @cta-primary-color;
  border-color: @cta-primary-color;
  &:hover {
    border-color: @cta-primary-hover-color;
    background-color: @cta-primary-hover-color;
  }
}

.cta-wrapper {
  &.link,
  &.link--dark,
  &.link-arrow,
  &.link-arrow--dark,
  &.text-button,
  &.link-button,
  &.link-button--dark,
  &.secondary--dark-reskin,
  &.left-facing-link-button-red,
  &.information,
  &.secondary-download,
  &.left-facing-link-button {
    .prefix-wrapper {
      display: table-cell;
    }
    .suffix-wrapper {
      display: table-row;
    }
  }
}

.cta-wrapper:hover {
  cursor: pointer;
}

.cta-wrapper.secondary--dark-reskin,
.cta-wrapper.text-button,
.cta-wrapper.secondary-download,
.cta-wrapper.information {
  .suffix-wrapper {
    display: block;
  }
}

.cta-wrapper.secondary,
.cta-wrapper.secondary--dark {
  color: var(--cta-link-color, @ig-grey-900);
  border-color: #2d2f2f;
  &:hover {
    background-color: @ig-grey-200;
  }
}

.cta-anchor {
  &.link,
  &.link-arrow,
  &.secondary,
  &.link-button,
  &.left-facing-link-button,
  &.left-facing-link-button-red {
    color: var(--cta-link-color, @ig-grey-900);
  }
}

.cta-anchor.primary,
.cta-anchor.secondary--dark,
.cta-anchor.link-button--dark {
  color: @white;
}

.cta-wrapper.link,
.cta-wrapper.link--dark,
.cta-wrapper.link-arrow,
.cta-wrapper.link-arrow--dark,
.cta-wrapper.link-button,
.cta-wrapper.link-button--dark {
  display: table;
  margin-left: var(--cta-link-ml, 0);
  margin-bottom: var(--cta-link-mb, @anchor-spacing);
  padding: var(--cta-link-padding, 0);
  font-size: var(--cta-font-size, 16px);
  line-height: var(--cta-line-height, 24px);
  .MatterMedium();
  color: var(--cta-link-color, @ig-grey-900);

  .cta__text:not(:empty) {
    & > * {
      display: inline;
    }
    &:after {
      content: '';
      width: var(--cta-link-text-width, 9px);
      height: var(--cta-link-text-height, 9px);
      margin: var(--cta-link-text-margin, 0 0 0 5px);
      display: inline-block;
      background-image: @cta-arrow-pointer;
      background-repeat: no-repeat;
      transform: var(--cta-link-transform, rotate(0deg));
    }
  }
}

.cta-wrapper.link-button,
.cta-wrapper.link-button--dark {
  padding: 7px 8px;
  border: 1px solid #9ea5a6; // closest color: @ig-grey-400
  &:hover {
    text-decoration: none;
    color: inherit;
    background-color: @ig-grey-200;
  }
}

.cta-wrapper.secondary--dark,
.cta-wrapper.link-button--dark {
  color: @white;
  border-color: @ig-grey-400;
  &:hover {
    color: @white;
    background-color: rgba(235, 235, 237, 0.2);
  }
}

.cta-anchor.link:hover,
h3:hover {
  text-decoration: underline;
  color: #c11516;
}

.cta-anchor.link--dark,
.cta-anchor.link-arrow--dark,
.cta-anchor.link--dark h3 {
  color: @white;
  &:hover {
    color: @white;
    text-decoration: underline;
  }
}

.cta-wrapper.left-facing-link-button,
.cta-wrapper.left-facing-link-button-red {
  background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMjgzNzIgNEwxMC40IDUuMjY1MzhMNy4wNjk3NyA5LjAxOTMzTDE2IDkuMDE5MzNMMTYgMTEuMDAxOEw3LjA2OTc3IDExLjAwMThMMTAuMzgxNCAxNC43NTU3TDkuMjY1MTIgMTZMNCAxMC4wMTA1TDkuMjgzNzIgNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=')
      no-repeat,
    @white;
  background-position: 28px 13px;
  border: 1px solid @ig-grey-400;
  border-radius: 40px;
  color: var(--black);
  font-weight: 600;
  padding: 13px 28px 13px 56px;
  position: relative;
  width: fit-content;
  &:hover {
    background-color: @ig-grey-100;
  }
  &.left-facing-link-button-red {
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMjgzNzIgNEwxMC40IDUuMjY1MzhMNy4wNjk3NyA5LjAxOTMzTDE2IDkuMDE5MzNMMTYgMTEuMDAxOEw3LjA2OTc3IDExLjAwMThMMTAuMzgxNCAxNC43NTU3TDkuMjY1MTIgMTZMNCAxMC4wMTA1TDkuMjgzNzIgNFoiIGZpbGw9IiNFMDFCMUMiLz4KPC9zdmc+Cg==');
    background-position: 28px 11px;
    border-color: var(--black);
    font-size: 16px;
  }
}

:host {
  .cta--right {
    margin-left: auto;
  }

  .cta--center {
    margin-left: auto;
    margin-right: auto;
  }
}

// Fix for Tag results page
.cta.link.tag-results-link {
  margin-bottom: 0;
}

/* tablet breakpoint */
@media (max-width: @medium-breakpoint) {
  .cta-wrapper {
    &.primary,
    &.secondary,
    &.secondary--dark {
      width: 100%;
      max-width: 350px;
    }

    &.link,
    &.link-button {
      margin-bottom: calc(var(--cta-link-mb, @anchor-spacing) - 10px);
    }
  }
}


/**
 * ============================================================================
 * EU Theme Mixins
 * ============================================================================
 */
.eu-theme-primary-button-basic(@bg-color: @eu-primary-bg; @text-color: @eu-primary-text) {
  background-color: @bg-color;
  border: none;
  color: @text-color;

  &:hover {
    border: none;
    opacity: .9;
  }

  .cta-anchor.primary {
    color: @text-color;
  }
}

.eu-theme-secondary-button-basic(@text-color: @eu-secondary-text; @border-color: @eu-secondary-border) {
  background: transparent;
  color: @text-color;
  border-color: @border-color;

  &:hover {
    background-color: transparent;
    color: @text-color;
  }

  .cta-anchor.secondary {
    color: @text-color;
  }
}

/**
 * ============================================================================
 * EU Theme CTA Component - Light Mode
 * ============================================================================
 * - Cross-browser compatible (replaces deprecated :host-context())
 * ============================================================================
 */
.eu-theme-active {
  &.cta-wrapper {
    font-size: clamp(.875rem, 1vw, 1rem);
    font-weight: 500;
    letter-spacing: -.01em;
    line-height: 1.3;
    box-sizing: border-box;

    &.primary {
      .eu-theme-primary-button-basic();
    }

    &.secondary {
      .eu-theme-secondary-button-basic();
    }
  }
}

/**
 * ============================================================================
 * EU Theme CTA Component - Dark Mode
 * ============================================================================
 * - Primary button: same as light mode
 * - Secondary button: light text and border (#edf0f2)
 * ============================================================================
 */
.eu-theme-active.eu-theme-dark-active {
  &.cta-wrapper {
    &.primary {
      .eu-theme-primary-button-basic();
    }

    &.secondary {
      .eu-theme-secondary-button-basic(@eu-dark-secondary-text, @eu-dark-secondary-border);
    }
  }
}